<div class="left-menu-container">
  <div class="cds-menu" data-test-data="cds-menu-container">
    @for (section of menu; track section.sectionId) {
    <div
      class="cds-menu-section"
      [class]="section.sectionCustomClass ? section.sectionCustomClass : ''"
      [attr.data-test-data]="section.sectionTestAttr">
      @for (menuItem of section.sectionOptions; track menuItem.parentRoutePath) {
      <div
        class="cds-menu-item"
        [class]="menuItem.customClass ? menuItem.customClass : ''"
        attr.data-test-data="{{ section.sectionId }}-{{ menuItem.testAttr }}"
        [ngClass]="{
          'selected-item': activeItem.routerLink === menuItem.routerLink && !isSubMenuSelected(menuItem),
          'disabled-item': menuItem.isDisabled
        }"
        (click)="handleMenuItemClick(menuItem)">
        <cds-option [option]="menuItem.option" [isDisabled]="menuItem.isDisabled ?? false"></cds-option>
      </div>
      <!-- Submenu section -->
      @if (menuItem.subMenu?.length && expandedItems.has(menuItem.id)) {
      <div class="submenu">
        @for (subMenuItem of menuItem.subMenu; track subMenuItem.routerLink) {
        <div
          class="cds-submenu-item"
          (click)="!subMenuItem.isDisabled && navigateToPage(subMenuItem)"
          attr.data-test-data="{{ subMenuItem.testAttr }}"
          [ngClass]="{
            'selected-item': activeItem && activeItem.routerLink === subMenuItem.routerLink,
            'disabled-item': subMenuItem.isDisabled
          }">
          <cds-option [option]="subMenuItem.option" [isDisabled]="subMenuItem.isDisabled ?? false"></cds-option>
        </div>
        }
      </div>
      } }
    </div>
    @if (!$last) {
    <div class="cds-section-divider"></div>
    } }
  </div>
</div>
